import { render, staticRenderFns } from "./agregaApoyo.vue?vue&type=template&id=33cf252e"
import script from "./agregaApoyo.vue?vue&type=script&lang=js"
export * from "./agregaApoyo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports